export const ActionType = {
  AddToCart: "add-to-cart",
  UpsellAdd: "upsell-add",
  AuthedAdd: "authed-add",
  QuickAdd: "quick-add",
  Switch: "switch",
  Checkout: "checkout",
};
